// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Container from "../layout/container"
import Content from "../../content/about-us/hero.json"
import ContactRedirection from "../contact-redirection"
import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const Hero = ({ langKey }) => {
  const { title, button } = Content[langKey]

  const data = useStaticQuery(graphql`
    query AboutUsHeroBackgroundQuery {
      desktop: file(relativePath: { eq: "AboutUsHeroDesktopBackground.png" }) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobile: file(relativePath: { eq: "AboutUsHeroMobileBackground.png" }) {
        childImageSharp {
          fluid(maxWidth: 376) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const sources = [
    data.mobile.childImageSharp.fluid,
    {
      ...data.desktop.childImageSharp.fluid,
      media: `(min-width: 750px)`,
    },
  ]

  return (
    <BackgroundImage
      fluid={sources}
      sx={{
        backgroundSize: `cover`,
        backgroundRepeat: `no-repeat`,
        backgroundPosition: `center bottom`,
        height: "85vh",
        display: `flex`,
      }}
    >
      <Container
        overrideCSS={{
          display: `flex`,
          justifyContent: "center",
          flexDirection: `column`,
        }}
      >
        <h1
          sx={{
            color: colors.code.secondary,
            fontSize: [`1.37rem`, `1.37rem`, `3rem`, `3rem`],
            fontWeight: fontWeights.black,
            textAlign: `center`,
            paddingBottom: `3rem`,
          }}
        >
          {title}
        </h1>
        <ContactRedirection
          href={
            langKey === "en"
              ? "https://www.jellyfish.com/en-us/contact-us"
              : "https://www.jellyfish.com/fr-fr/contact-us"
          }
          buttonContent={button}
        />
      </Container>
    </BackgroundImage>
  )
}

export default Hero
